import {AbstractControl, ValidationErrors} from '@angular/forms'
import {RxwebValidators} from '@rxweb/reactive-form-validators'

// mailto:a@b.com, optionally more comma separated addresses and a ?subject=...&body=... query
const MAILTO_REGEX = /^mailto:[^\s@,?]+@[^\s@,?]+\.[^\s@,?]+(,[^\s@,?]+@[^\s@,?]+\.[^\s@,?]+)*(\?.*)?$/i;

// Accepts a web URL or a mailto: link, reports the same 'url' error as RxwebValidators.url()
export function ValidateWeblink(control: AbstractControl): ValidationErrors | null {
  if (typeof control.value === 'string' && MAILTO_REGEX.test(control.value.trim())) {
    return null
  }
  return RxwebValidators.url()(control)
}
